import React, { Component, Suspense } from "react";
import { Provider } from "react-redux";
import store from "./store";
// import Router from "./router/RouterComponent";
import Loader from "./utils/common/Loader/Loader";
const Router = React.lazy(() => import('./router/RouterComponent'));

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Suspense fallback={<div className="flex w-full h-screen items-center justify-center"> <Loader/></div>}>
        <Router/>
        </Suspense>
        {/* <Router /> */}
      </Provider>
    );
  }
}

export default App;
